export function getImageDataUsingCanvas({
  source,
  width,
  height,
}: {
  source: CanvasImageSource;
  width: number;
  height: number;
}): ImageData | undefined {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx?.drawImage(source, 0, 0, width, height);
  return ctx?.getImageData(0, 0, width, height);
}
